export default __webpack_public_path__ + "static/media/parc7.d84c547c.jpg";